export const modalExitAction = {
  walkthroughComplete: 'walkthrough_complete',
  logOut: 'log_out',
  logIn: 'log_in',
} as const;
